import { render } from "./ChatDock.vue?vue&type=template&id=497052b8&scoped=true"
import script from "./ChatDock.vue?vue&type=script&lang=js"
export * from "./ChatDock.vue?vue&type=script&lang=js"

import "./ChatDock.vue?vue&type=style&index=0&id=497052b8&lang=css"
import "./ChatDock.vue?vue&type=style&index=1&id=497052b8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497052b8"]])

export default __exports__